/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetTreatmentPlanErrorResponse, GetTreatmentPlanResponse } from './api.schemas';

import { api } from '../util/http';

export const getTreatmentPlan = (encounterId: number, signal?: AbortSignal) => {
  return api<GetTreatmentPlanResponse>({
    url: `/api/encounters/${encounterId}/treatmentplan`,
    method: 'GET',
    signal,
  });
};

export const getGetTreatmentPlanQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/treatmentplan`] as const;
};

export const getGetTreatmentPlanQueryOptions = <
  TData = Awaited<ReturnType<typeof getTreatmentPlan>>,
  TError = GetTreatmentPlanErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTreatmentPlan>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTreatmentPlanQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTreatmentPlan>>> = ({ signal }) =>
    getTreatmentPlan(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTreatmentPlan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTreatmentPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getTreatmentPlan>>>;
export type GetTreatmentPlanQueryError = GetTreatmentPlanErrorResponse;

export function useGetTreatmentPlan<
  TData = Awaited<ReturnType<typeof getTreatmentPlan>>,
  TError = GetTreatmentPlanErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTreatmentPlan>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTreatmentPlan>>,
          TError,
          Awaited<ReturnType<typeof getTreatmentPlan>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTreatmentPlan<
  TData = Awaited<ReturnType<typeof getTreatmentPlan>>,
  TError = GetTreatmentPlanErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTreatmentPlan>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTreatmentPlan>>,
          TError,
          Awaited<ReturnType<typeof getTreatmentPlan>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTreatmentPlan<
  TData = Awaited<ReturnType<typeof getTreatmentPlan>>,
  TError = GetTreatmentPlanErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTreatmentPlan>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTreatmentPlan<
  TData = Awaited<ReturnType<typeof getTreatmentPlan>>,
  TError = GetTreatmentPlanErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTreatmentPlan>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTreatmentPlanQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
